<template>
  <div>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="students"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.srno="{ item }">
        <span class="table-tutor-srno">{{ item.srno }}</span>
      </template>

      <template v-slot:item.class_link="{ item }">
        <a
          v-if="item.class_link != 'nil' && item.session_type != 'incenter'"
          :href="item.class_link"
          class="table-tutor-name"
          target="_blank"
          >Join</a
        >
      </template>

      <template v-slot:item.session_date="{ item }">
        <span class="table-tutor-date">{{ item.session_date | formatDate }}</span>
      </template>

      <template v-slot:item.session="{ item }">
        <span class="table-tutor-session">{{ item.session }}</span>
      </template>

      <template v-slot:item.session_type="{ item }">
        <span class="table-tutor-session">{{ (item.session_type == 'online') ? 'Online' : 'In Center' }}</span>
      </template>

      <template v-slot:item.subject_name="{ item }">
        <span>{{ item.subject_name != null ? item.subject_name : "-" }}</span>
      </template>

      <template v-slot:item.class_name="{ item }">
        <span>{{ item.class != null ? item.class.class_name : "-" }}</span>
      </template>

      <template v-slot:item.class_work="{ item }">
        <span v-if="item.works.length > 0" v-for="work in item.works">
          <v-row style="width: 200px" v-if="work.work.work_type == 'class'">
            <v-col>
              <a :href="work.work.work_file" target="_blank">
                <v-btn color="#E41B1BF7" elevation="1" dark small>
                  <v-icon dense class="mr-2">fas fa-file-pdf</v-icon
                  >{{ work.work.work_name }}
                  <v-icon dense class="mr-2">mdi-arrow-down-bold</v-icon>
                </v-btn>
              </a>
            </v-col>
            <v-col v-if="work.uploaded_work == '0'">
              <v-btn @click="uploadWork(work)" color="green" elevation="1" dark small>
                <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>Upload
                <v-icon dense class="mr-2">mdi-arrow-up-bold</v-icon>
              </v-btn>
            </v-col>
            <v-col v-else>
              <a :href="work.uploaded_file" target="_blank">
                <v-btn color="green" elevation="1" dark small>
                  <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>Uploaded work
                  <v-icon dense class="mr-2">mdi-arrow-down-bold</v-icon>
                </v-btn>
              </a>
            </v-col>
          </v-row>
        </span>
      </template>

      <template v-slot:item.home_work="{ item }">
        <span v-if="item.works.length > 0" v-for="work in item.works">
          <v-row style="width: 200px" v-if="work.work.work_type == 'home'">
            <v-col>
              <a :href="work.work.work_file" target="_blank">
                <v-btn color="#E41B1BF7" elevation="1" dark small>
                  <v-icon dense class="mr-2">fas fa-file-pdf</v-icon
                  >{{ work.work.work_name }}
                  <v-icon dense class="mr-2">mdi-arrow-down-bold</v-icon>
                </v-btn>
              </a>
            </v-col>
            <v-col v-if="work.uploaded_work == '0'">
              <v-btn @click="uploadWork(work)" color="green" elevation="1" dark small>
                <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>Upload
                <v-icon dense class="mr-2">mdi-arrow-up-bold</v-icon>
              </v-btn>
            </v-col>
            <v-col v-else>
              <a :href="work.uploaded_file" target="_blank">
                <v-btn color="green" elevation="1" dark small>
                  <v-icon dense class="mr-2">fas fa-file-pdf</v-icon>Uploaded work
                  <v-icon dense class="mr-2">mdi-arrow-down-bold</v-icon>
                </v-btn>
              </a>
            </v-col>
          </v-row>
        </span>
      </template>
      <!-- <template v-slot:item.upload_work="{ item }">
           <v-icon @click="uploadWork(item)" color="success">mdi-file-edit</v-icon>

    </template> -->
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
          students.length
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs2 }">
        <!--           
        <v-btn color="#6A158E" dark  v-bind="attrs2"
        v-on="on">+ Add Session</v-btn> -->
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Upload Work</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Work File</label>
              <v-file-input
                label="Choose File"
                @change="fileSelected"
                accept="image/jpeg,image/png,application/pdf,image/jpg"
                persistent-hint
                hint="File Should be PDF"
                show-size
                counter
                chips
                solo
              ></v-file-input>
            </v-col>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="storeWork">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ClassTable",
  props: ["tab"],
  data() {
    return {
      dialog: false,
      page: 1,
      data: {},
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        {
          text: "SrNo1.",
          sortable: true,
          value: "group_session_id",
        },
        {
          text: "Class",
          value: "class_name",
          sortable: false,
        },
        {
          text: "Subject",
          value: "subject_name",
          sortable: false,
        },
        {
          text: "Tutor Name",
          value: "group.tutor.tutor_fname",
          sortable: true,
        },
        {
          text: "Date",
          value: "session_date",
          sortable: true,
        },
        {
          text: "Start Time",
          value: "session_start_time",
          sortable: true,
        },
        {
          text: "End Time",
          value: "session_end_time",
          sortable: true,
        },
        {
          text: "Session Type",
          value: "session_type",
          sortable: false,
        },
        {
          text: "Session Link",
          value: "class_link",
          sortable: false,
        },
        {
          text: "Class Work",
          value: "class_work",
          sortable: false,
        },
        {
          text: "Home Work",
          value: "home_work",
          sortable: false,
        },
        // { text: "Upload Work", value: "upload_work", sortable: false }
      ],
      students: [],
    };
  },
  watch: {
    tab: function (val) {
      // watch it
      if (val == 1) {
        this.getItems();
      }
    },
  },
  methods: {
    uploadWork(item) {
      console.log(item);
      this.data.work_session_wise_id = item.work_session_wise_id;
      this.dialog = true;
    },
    storeWork() {
      axios.post("store/student/work", this.data).then((response) => {
        console.log(response);
        this.dialog = false;
      });
    },
    fileSelected(file) {
      console.log(file);
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.data.file = reader.result;
        console.log(reader.result);
      };
      // this.data.files = [...file]
    },
    makeQueryParams() {
      const user = JSON.parse(localStorage.getItem("user"));

      return {
        ...this.formQueryParams(),
        tutor: user.id,
        status: 2,
      };
    },
    markAttendance(item) {
      var user = localStorage.getItem("user");
      item["user"] = JSON.parse(user);
      axios.post("mark/attendance", item).then((response) => {
        console.log(response);
        // this.loading = false
        // this.students = response.data
      });
    },
    getItems() {
      const user = JSON.parse(localStorage.getItem("user"));

      this.loading = true;
      axios
        .get(apiRoutes.students.classes + "/" + user.id + "/upcoming")
        .then((response) => {
          console.log(response.data.group_sessions);
          this.loading = false;
          this.students = response.data;
        });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }

  &-date {
    font: 500 13px/13px Gotham;
    color: #0ebddff7;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>
